import React from 'react';
import './FormDropdown.scss';

interface FormDropdownProps {
    dropdownId: string;
    classNames?: String;
    options: Array<number | string>;
    handlechange: (e: any) => void;
    dropdownValue: string;
    dropdownName: string;
    blurValidation: (e: any) => void;
    placeholder?: string;
}
const FormDropdown: React.FC<FormDropdownProps> = ({
    dropdownId,
    classNames = '',
    options,
    handlechange,
    dropdownValue,
    dropdownName,
    blurValidation,
    placeholder = '',
}) => (
    <select
        name={dropdownName}
        className={`form-dropdown ${classNames}`}
        id={dropdownId}
        onChange={handlechange}
        onBlur={blurValidation}
        value={dropdownValue}
    >
        <option className="form-dropdown-options" value="" disabled>
            {placeholder}
        </option>
        {options.map(optionValue => (
            <option className="form-dropdown-options" key={`${dropdownId}_${optionValue}`} value={optionValue}>
                {optionValue}
            </option>
        ))}
    </select>
);

export default FormDropdown;
